<template>
  <div>
    <el-card>
      <el-table :data="listData" border>
          <el-table-column prop="doctor" label="医生名称"></el-table-column>
          <el-table-column prop="deptname" label="科室名称"></el-table-column>
        <el-table-column prop="patname" label="就诊人姓名"></el-table-column>
        <el-table-column prop="booktime" label="病历创建时间"></el-table-column>
        <el-table-column label="详情" width="150">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click.prevent="getDetails(scope.row)"
              >详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
      getDetails(row){
          window.localStorage.setItem("medicalList", JSON.stringify(row));
          this.$router.push({
            path: "/main/medicalListDetails",
          });
      },
    async init() {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        clinicNumber: that.$route.query.id,
        commonPatIdcard:''
      };
      let res = await this.$http(
        "smarthos.user.book.case.history.list.his.system",
        options
      );
      if (res.code == 0) {
        that.listData = res.list;
      }
    },
  },
};
</script>
<style>
</style>